<template>
  <div :class="classes()">
    <div :class="`${el}__items`">
      <template v-for="(_, slot) in $slots">
        <div :class="`${el}__item`" v-bind:key="slot">
          <div :class="`${el}__radioButton`">
            <slot :name="slot"></slot>
          </div>
        </div>
      </template>
    </div>
    <Copy
      v-if="error"
      element="div"
      size="s"
      :staticClass="`${el}__helperText`"
      color="supportDanger"
    >
      {{ error }}
    </Copy>
  </div>
</template>

<script>
/**
 * Example:
 * Every node needs an unique slot
 *
  <BaseRadioGroup>
    <BaseRadio slot="1" id="test4-1" name="test4" label="Ein Label 1" checkmark />
    <BaseRadio slot="2" id="test4-2" name="test4" label="Ein Label 2" checkmark />
    <BaseRadio slot="3" id="test4-3" name="test4" label="Ein Label 3" checkmark />
  </BaseRadioGroup>
 */

import Copy from '@/objects/Copy';

export default {
  name: 'BaseRadioGroup',
  components: {
    Copy,
  },
  props: {
    direction: {
      type: String,
      default: 'horizontal',
      validator: (val) => ['vertical', 'horizontal'].includes(val),
    },
    error: String,
    flexBasisAuto: Boolean,
  },
  data() {
    return {
      el: 'o-baseRadioGroup',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--flexBasisAuto`]: this.flexBasisAuto,
          [`${el}--${this.direction}`]: this.direction,
        };
      },
    };
  },
};
</script>
